const WWW_STRING = 'www.';

/**
 * Gets the domain (or, hostname) from a URL. By default, strips the 'www.' prefix.
 */
export function getHostnameFromUrl(
    url: string,
    stripWww: boolean = true,
): string {
    const urlObj = new URL(url);
    if (stripWww && urlObj.hostname.startsWith(WWW_STRING)) {
        return urlObj.hostname.substring(WWW_STRING.length);
    }
    return urlObj.hostname;
}
